import React from "react";
import { ShoppingBag } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "./CartContext";
import "./cart.scss";

const HIDDEN_PREFIXES = [
  "/admin",
  "/login",
  "/register",
  "/verify",
  "/resetPassword",
  "/cart",
  "/flight-checkout",
  "/esim/payment-step",
];

export default function CartFloatingButton() {
  const { count } = useCart();
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return null;

  return (
    <Link className="floating-cart-button" to="/cart" aria-label={`Open cart with ${count} item${count === 1 ? "" : "s"}`}>
      <ShoppingBag aria-hidden="true" />
      {count > 0 && <span>{count > 99 ? "99+" : count}</span>}
    </Link>
  );
}
